import axios from '@/plugins/axios'

function update(data, id) {
  return axios.patch(`/currency-exchange-margin-rates/${id}`, data)
    .then(response => {
      return response.data
    })
}
function store(data) {
  return axios.post('/currency-exchange-margin-rates', data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/currency-exchange-margin-rates', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  }
}
